<template>
  <div class="index">
    <div class="child-list">
      <div class="child-item" v-for="(item, index) in list"  @click="goPage('/help/child/info?id='+item.id)">
        <div class="child-info">
          <img class="child-head" :src="item.image_input" alt="">
          <div>
            <div class="child-name">
              <div>{{item.nickname}}</div>
              <img class="gender-img" :src="`${require('@assets/images/dywfl/gender1.png')}`" alt="" v-if="item.sex=='男'">
              <img class="gender-img" :src="`${require('@assets/images/dywfl/gender2.png')}`" alt="" v-else>
            </div>
            <div class="child-time">{{item.add_time}}</div>
          </div>
        </div>
        <div class="child-intro omit2">{{item.synopsis}}</div>
        <div class="child-address">
          <div class="iconfont icon-dizhi"></div>
          <div class="omit1">{{item.address}}</div>
        </div>
        <div class="info-btn">查看详情</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDifficulty} from "@api/public";
export default {
  name: "CateList",
  components: {
  },
  props: {},
  data: function () {
    return {
		list:[]
    };
  },
  watch: {

  },
  mounted: function () {
	this.getDifficulty();
  },
  methods: {
	//获取轮播图/详情
	getDifficulty(){
		getDifficulty().then(res => {
		  this.list=res.data
		});
	},
	//查看详情
    goPage(url){
      this.$router.push({path:url});
    }
  },
};
</script>
<style lang="scss" scoped>
.index {
  min-height: 100vh;
  background-color: #FEE1E5;
}

.child-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 .2rem;

  .child-item {
    width: calc(50% - .1rem);
    background-color: #fff;
    border-radius: .1rem;
    margin: .2rem 0;
    padding: .3rem .15rem;
    animation: fade_in .5s;
    .child-info{
      display: flex;
      align-items: center;
      border-bottom: 1px dashed #C9C9C9;
      padding-bottom: .3rem;
      .child-head{
        width: .85rem;
        height: .85rem;
        border-radius: .1rem;
        margin-right: .2rem
      }
      .child-name{
        display: flex;
        align-items: flex-start;
        font-size: .28rem;
      }
      .child-time{
        font-size: .24rem;
        color: #999;
        margin-top: .05rem;
      }
      .gender-img{
          width: .16rem;
          height: .16rem;
        }
    }

    .child-intro{
      font-size: .26rem;
      color: #666;
      margin-top: .25rem;
    }
    .child-address{
      display: flex;
      align-items: center;
      font-size: .22rem;
      line-height: 1;
      margin-top: .25rem;
      .iconfont{
        font-size: .3rem;
        color: #B3B3B3;
      }
    }

    .info-btn{
      line-height: .49rem;
      text-align: center;
      background-color: #F05877;
      color: #fff;
      border-radius: .49rem;
      margin-top: .25rem;
    }
  }
}
</style>
